import { twMerge } from 'tailwind-merge'

interface ResumeItemProps {
  label: string
  value?: string
  valueIsPending?: boolean
  className?: string
  labelClassName?: string
  valueClassName?: string
}

export const ResumeItem = ({
  label,
  value,
  valueIsPending,
  className,
  labelClassName,
  valueClassName,
}: ResumeItemProps) => {
  return (
    <div className={twMerge('flex flex-col gap-2 bg-white-100 p-4 rounded-lg', className)}>
      <p className={twMerge('text-[10px] font-light leading-3', labelClassName)}>{label}</p>

      {valueIsPending ? (
        <div className="h-3 w-20 animate-pulse bg-white-300 rounded-sm" />
      ) : (
        <p className={twMerge('text-xs font-bold leading-3', valueClassName)}>{value || '--'}</p>
      )}
    </div>
  )
}
